import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { Icon } from "../icon";
import { Loading } from "../loading";
import styles from "./state-message.module.scss";
import type { StateMessageViewProps } from "./types-state-message";

export function StateMessageView({
  className,
  style,
  role,
  ariaLive,
  variant,
  dataInline,
  testId,
  rest,
  showLoading,
  iconName,
  iconClass,
  classNames: partClassNames,
  partTestId,
  title,
  description,
  action,
  actionIcon,
}: StateMessageViewProps) {
  return (
    <div
      className={classNames(styles.root, className)}
      style={style}
      role={role}
      aria-live={ariaLive}
      data-variant={variant}
      data-inline={dataInline}
      data-testid={testId}
      {...rest}
    >
      {showLoading ? (
        <Loading
          aria-hidden
          className={classNames(styles.icon, partClassNames?.icon)}
          testId={partTestId("icon")}
        />
      ) : iconName ? (
        <Icon
          name={iconName}
          className={classNames(styles.icon, partClassNames?.icon)}
          testId={partTestId("icon")}
        />
      ) : (
        <i
          className={classNames(iconClass, styles.icon, partClassNames?.icon)}
          aria-hidden
          data-testid={partTestId("icon")}
        />
      )}
      <p
        className={classNames(styles.title, partClassNames?.title)}
        data-testid={partTestId("title")}
      >
        {title}
      </p>
      {description ? (
        <p
          className={classNames(styles.description, partClassNames?.description)}
          data-testid={partTestId("description")}
        >
          {description}
        </p>
      ) : null}
      {action ? (
        <Button
          type="button"
          text
          size="small"
          label={action.label}
          icon={actionIcon}
          onClick={action.onClick}
          className={classNames(styles.action, partClassNames?.action)}
          data-testid={action.testId ?? partTestId("action")}
        />
      ) : null}
    </div>
  );
}
